<template>
  <div class="grid lg:grid-cols-11 row-gap-12 lg:row-gap-4 items-center">
    <div
        class="col-span-11 lg:col-span-6 text-text-secondary text-sm font-medium flex items-center leading-relaxed -mt-1">
      <IconLockOpen class="text-icon mr-6"/>
      <div>
        <div>{{ $t('lockedText') }}</div>
        <span class="text-sm text-red font-normal
            border-b border-red border-dashed border-opacity-30
            transition duration-200
            hover:border-opacity-100 cursor-pointer"
              @click="showTip = !showTip">{{ $t('forgotText') }}</span>
      </div>
    </div>
    <div class="col-span-11 lg:col-span-5 grid grid-cols-7 col-gap-8">
      <PasswordInput class="col-span-4" v-model.trim="$v.password.$model"
                     :label="$t('passwordLabel')"
                     :password-reveal="true"
                     :class="{'--error': $v.password.$error}"
                     @keydown.enter="unlockSettings">
        <template slot="errors">
          <div class="error" v-if="!$v.password.required">{{ $t('errors.required') }}</div>
        </template>
      </PasswordInput>
      <BaseButton class="col-span-3"
                  theme="red"
                  @click="unlockSettings"
                  :disabled="saving">
        {{ $t('applyBtn') }}
      </BaseButton>
    </div>
    <div class="col-span-11 lg:pl-12" v-if="showTip">
      <p class="text-sm text-text-ternary mb-4 leading-relaxed" v-html="$t('passwordTip')"></p>
      <BaseButton theme="default" size="sm"
                  @click="logout">
        {{ $t('logOutFromCabinet') }}
      </BaseButton>
      <BaseButton class="mt-4 lg:ml-4 lg:mt-0"
                  theme="default" size="sm"
                  :disabled="PINUpdating"
                  @click="updatePIN">
        {{ $t('createPIN') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import BaseInput from "@/components/UI/BaseInput/BaseInput";
import BaseButton from "@/components/UI/BaseButton";
import IconLockOpen from "@/components/icons/IconLockOpen";
import PasswordInput from "@/components/UI/BaseInput/PasswordInput";
import {mapActions, mapMutations} from "vuex";

export default {
  name: "PasswordGuardPASS",
  components: {
    PasswordInput,
    IconLockOpen,
    BaseButton,
    BaseInput,
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      password: '',
      showTip: false,
      PINUpdating: false,
    }
  },
  validations: {
    password: {
      required,
    },
  },
  methods: {
    ...mapMutations('auth', ['logout']),
    ...mapActions('cabinet/user', ['setNewSettingsPIN']),
    ...mapMutations('cabinet/user', ['setUserUsesPIN']),
    unlockSettings() {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.saving) {
        this.$emit('unlock', {password: this.password})
      }
    },
    async updatePIN() {
      this.PINUpdating = true;
      const res = await this.setNewSettingsPIN()
      if (res.body.success) {
        this.$toasted.success(this.$t('pinSetSuccess'))
        this.setUserUsesPIN()
        this.PINUpdating = false;
      } else {
        this.PINUpdating = false;
      }
    }
  },
  i18n: {
    messages: {
      en: {
        lockedText: 'To apply changes enter your password',
        passwordLabel: 'Enter password',
        applyBtn: 'Apply',
        forgotText: 'Forgot password?',
        passwordTip: 'To restore your password, logout from cabinet <br> and then restore it as usual in "Forgot password" form.',
        logOutFromCabinet: 'Log out',
        createPIN: 'New PIN code sent on your e-mail',
        pinSetSuccess:'New PIN code sent on your e-mail'
      },
      ru: {
        lockedText: 'Чтобы изменить настройки нужно указать ваш пароль',
        passwordLabel: 'Ваш пароль',
        applyBtn: 'Подтвердить',
        forgotText: 'Забыли пароль?',
        passwordTip: 'Для восстановления пароля вам нужно будет выйти из кабинета <br> и восстановить пароль через почту, как обычно.',
        logOutFromCabinet: 'Выйти из кабиента',
        createPIN: 'Создать PIN и отправить на почту',
        pinSetSuccess:'Новый PIN отправлен на почту'
      }
    }
  }
}
</script>